{
  "(optional)": "(volitelně)",
  "(required)": "(požadováno)"
}
